<template>
  <div></div>
  <!--  <div class="activity-bar" v-if="data" v-buried  data-buried="BG_HUODONGBANNER" v-clickBuried data-click-buried="CLICK_HUODONGBANNER">
        <div class="bar-content">
            <img class="bar-image"
                :src="data.left_img"
                alt="">
            <div class="bar-text">
                <van-notice-bar ref="notice" class="notice-bar" color="rgba(0, 0, 0, 0.8)" background="rgba(255,255,255,0)"  :text="data.content" />
            </div>
            <div class="bar-right" @click="bindClick"><span>{{data.click_content}}</span><span class="iconfont icon-you"></span></div>
        </div>
    </div> -->
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    reset() {
      this.$refs.notice.reset()
    },
    bindClick() {
      if (this.data.router) {
        this.$betterwe.jumpRoute(this.data.router)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .van-notice-bar {
    padding: 0 6px;
  }
  .bar-content {
    width: 343px;
    box-sizing: border-box;
    height: 39px;
    background: linear-gradient(
      270deg,
      rgba(255, 247, 205, 0.9) 0%,
      #fff5b6 100%
    );
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 0px 10px 0px 4px;
    .bar-image {
      height: 100%;
      width: auto;
    }

    .bar-text {
      height: 100%;
      flex: 1;
      flex-shrink: 0;
      margin-right: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
      .notice-bar {
        width: 100%;
        height: 100%;
      }
    }

    .bar-right {
      font-weight: bold;
      font-size: 10px;
      color: #ff8a4c;
      line-height: 14px;
      .iconfont {
        font-size: 12px;
      }
    }
  }
}
</style>
